const getRatios = (count) => {
	const total = count.reduce((sum, c) => sum + c, 0);
	return count.map((c) => c / total);
};
export { getRatios };

//# sourceMappingURL=index148.js.map